import {
    PopupDismissedKeys,
    PopupDismissedReason
} from '@mintdata/mint-kit/impl/components/popover/PopupDismissedReason';
import {PopupManager} from '@mintdata/mint-kit/impl/components/popover/PopupManager';
import {bind} from 'bind-decorator';

export class PopupKeyboardCloser
{
    constructor(public popupManager:PopupManager)
    {
    }

    private static readonly ESC = 27;

    public startListeningToKeyboardEvents():PopupKeyboardCloser
    {
        window.addEventListener('keydown', this._onKeyDown, false /* bubbling phase */);
        return this;
    }

    @bind
    private _onKeyDown(e:any)
    {
        if( e.keyCode === PopupKeyboardCloser.ESC )
        {
            this.popupManager.hideTopmost(PopupDismissedReason.keyboard(PopupDismissedKeys.ESC));
        }
    }
}
